import * as React from "react";
import type { SVGProps } from "react";
const SvgBell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 18h3.98c.46 0 .85-.32.97-.75s-.07-.9-.47-1.12c-.8-.45-1.36-1.27-1.49-2.19v-2.98a7.987 7.987 0 0 0-4.07-6.6A3.01 3.01 0 0 0 11.99 2a3.01 3.01 0 0 0-2.93 2.36C6.66 5.7 5.12 8.18 4.99 11v2.94c-.13.91-.68 1.73-1.49 2.19a.99.99 0 0 0-.47 1.12c.12.44.52.75.97.75h4c0 2.21 1.79 4 4 4s4-1.79 4-4Zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2h4Zm3.63-2a4.91 4.91 0 0 1-.62-1.88V11c-.1-2.17-1.42-4.15-3.43-5.1-.35-.17-.57-.52-.57-.9 0-.55-.45-1-1-1s-1 .45-1 1c0 .39-.22.74-.57.9a5.998 5.998 0 0 0-3.43 5.14v3.07c-.08.67-.3 1.31-.62 1.88l-.02.01h11.26Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBell;
